module.exports = __webpack_public_path__ + "img/new-icon.b80f9d59.svg";